// Türk Lirası para formatı için yardımcı fonksiyonlar.

/**
 * "₺1.234,56" gibi TR formatlı bir metni Number'a çevirir.
 * Parse başarısız olursa 0 döner.
 */
export function parseTRY(text) {
  if (text === null || text === undefined) return 0;
  if (typeof text === 'number') return Number.isFinite(text) ? text : 0;

  let s = String(text).trim();
  if (!s) return 0;

  // Para sembollerini ve boşlukları temizle
  s = s.replace(/[₺\s]/g, '').replace(/TL/gi, '').replace(/TRY/gi, '');

  // Binlik ayraç '.' kaldır, ondalık ',' -> '.'
  s = s.replace(/\./g, '').replace(',', '.');

  const num = Number(s);
  return Number.isFinite(num) ? num : 0;
}

/**
 * Number'ı TR formatlı para metnine çevirir. Örn: 1234.5 -> "₺1.234,50"
 */
export function formatTRY(value) {
  const num = typeof value === 'number' ? value : parseTRY(value);
  return new Intl.NumberFormat('tr-TR', {
    style: 'currency',
    currency: 'TRY',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(num);
}

export default { parseTRY, formatTRY };

